module.exports = __webpack_public_path__ + "img/daizy_market.3c8dda57.jpg";